const Components = {};
export default Components;

Components.Dependency = class Dependency {
  constructor(args) {
    this.pollIsLoaded = this.pollIsLoaded.bind(this);
    this.url = args.url;
    this.klass = args.klass;
    this.onReady = args.onReady;
    if (this.isLoaded()) {
      if (this.onReady) {
        this.onReady();
      }
    } else {
      this.load();
    }
  }

  load() {
    if (this.isLoaded()) {
      if (this.onReady) {
        this.onReady();
      }
    } else {
      const t = document.createElement("script");
      t.setAttribute("src", this.url);
      t.onload = this.pollIsLoaded;
      document.head.appendChild(t);
    }
  }

  pollIsLoaded() {
    let count = 0;
    this.interval = setInterval(() => {
      count += 1;
      if (this.isLoaded()) {
        if (this.onReady) {
          this.onReady();
        }
        clearInterval(this.interval);
      }
      if (count === 5) {
        clearInterval(this.interval);
      }
    }, 500);
  }

  isLoaded() {
    return !!window[this.klass];
  }
};

Components.Base = class Base {
  static create(args) {
    const $el = $(args.el);
    if (!$el.data(args.selector)) {
      return new this(args);
    }
    return false;
  }

  constructor(args) {
    this.handlers = [];
    this.selector = args.selector;
    this.context = args.context || {};
    if (args.el) {
      this.el = args.el;
      this.$el = $(this.el);
      this.$el.data(this.selector, true);
    }
    this.prepareDom(args);
    this.initialize(args);
    this.bind(args);
  }

  destroy() {
    this.deinitialize();
    this.unbindAuto();
    this.unbind();
    if (this.$el) {
      this.$el.data(this.selector, false);
    }
    if (this.el) {
      delete this.el;
      delete this.$el;
    }
  }

  isChildOf(parent) {
    // Guard both sides: this.el may be deleted by destroy(), and an
    // in-flight live-update AJAX can fire after the target is replaced.
    if (!this.el) return false;
    const parentEl = $(parent)[0];
    if (!parentEl) return false;
    return $.contains(parentEl, this.el);
  }

  on(...args) {
    this.handlers.push(args);
    if (args[0] instanceof jQuery) {
      args[0].on(...args.slice(1));
    } else {
      this.$el.on(...args);
    }
  }

  unbindAuto() {
    this.handlers.forEach((args) => {
      if (args[0] instanceof jQuery) {
        args[0].off(...args.slice(1));
      } else {
        this.$el.off(...args);
      }
    });
    this.handlers = [];
  }

  /* eslint-disable */
  prepareDom(args) {}
  initialize(args) {}
  bind(args) {}
  unbind(args) {}
  deinitialize(args) {}
  onAllComponentsReady(args) {}
  /* eslint-enable */
};

class ComponentInstanceCollection {
  constructor() {
    this.items = [];
  }

  unloadAll() {
    this.items.forEach((item) => item.destroy());
    this.items = [];
  }

  unloadFragment(parent) {
    const remainingItems = [];
    this.items.forEach((item) => {
      if (item.isChildOf(parent)) {
        item.destroy();
      } else {
        remainingItems.push(item);
      }
    });
    this.items = remainingItems;
  }

  create(args) {
    const instance = args.klass.create(args);
    if (instance) {
      this.items.push(instance);
    }
    return instance;
  }
}

class ComponentCollection {
  constructor(args) {
    this.instances = args.instances;
    this.items = [];
  }

  register(args) {
    this.items.push(args);
  }

  loadAll() {
    const c = $('meta[name="page-context"]').attr("content");
    window.context = c ? $.parseJSON(c) : {};
    this.loadFragment("body");
  }

  loadFragment(parent) {
    const $parent = $(parent).slice(0, 1);
    const newInstances = [];
    this.items.forEach((item) =>
      Array.from($parent.find(item.selector).addBack(item.selector)).forEach(
        (el) =>
          newInstances.push(
            this.instances.create({
              klass: item.klass,
              el,
              selector: item.selector,
              context: window.context,
            }),
          ),
      ),
    );

    newInstances.forEach((item) => {
      if (item.onAllComponentsReady) {
        item.onAllComponentsReady();
      }
    });
  }

  unloadAll() {
    this.instances.unloadAll();
  }
}

Components.instances = new ComponentInstanceCollection();
Components.collection = new ComponentCollection({
  instances: Components.instances,
});
